<div class="container">
  <header>
    <h1>{{ 'mainPage.title' | translate }}</h1>
    <div class="header-actions">
      <p-button
        [label]="'mainPage.backToList' | translate"
        icon="pi pi-arrow-left"
        severity="info"
        size="small"
        (onClick)="goBackToList()"
      />
      <p-button
        [label]="'mainPage.logout' | translate"
        icon="pi pi-sign-out"
        size="small"
        severity="secondary"
        (onClick)="signOut()"
      />
    </div>
  </header>

  @if (isJobLoaded()) {
    <main class="main">
      <form [formGroup]="captureDataForm()">
        <div class="capture-invoice-job-header">
          <h2>{{ 'mainPage.jobTitle' | translate }}{{ jobId() }}</h2>
          <div class="capture-invoice-job-actions">
            <p-button
              [label]="'mainPage.save' | translate"
              icon="pi pi-save"
              (onClick)="onSaveCaptureDataForm()"
            />
            <p-button
              [label]="'mainPage.complete' | translate"
              icon="pi pi-check-circle"
              type="submit"
              severity="success"
              (onClick)="onCompleteJob()"
            />
          </div>
        </div>
        <app-invoice-viewer [fileSrc]="invoiceFileUrl()" />
        <app-capture-data-headers-form [headerCaptureDataForm]="captureHeadersDataForm()" />
        <app-capture-data-line-items-form
          [captureDataForm]="captureDataForm()"
          [lineItemProps]="captureLineItemProps"
          lineItemsFormGroupName="line_items"
        />
      </form>
    </main>
  } @else {
    <div class="message-container">
      <p>{{ message() }}</p>
      @if (!isLoadEnd()) {
        <i class="pi pi-spin pi-spinner"></i>
      }
    </div>
  }

  <p-toast />
</div>
